import {
    FetchState,
    AvidiaStatementState,
    AvidiaStatementsList,
} from "@/shared/types";
import Vue from "vue";
import * as BankService from "@/shared/api/bankService";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: AvidiaStatementState = {};


export const useAvidiaStatementsStore = defineStore("avidiaStatements", {
    state: (): AvidiaStatementState => (_.cloneDeep(initialState)),
    getters: {
        loading: state => (year: number) => state[year] && state[year].fetchState === FetchState.Loading,
        loaded: state => (year: number) => state[year] && state[year].fetchState === FetchState.Loaded,
        statements: state => (year: number) => state[year] && state[year].listing.statements,
        priorYear: state => (year: number) => state[year] && state[year].listing.priorYear,
        nextYear: state => (year: number) => state[year] && state[year].listing.nextYear,
    },
    actions: {
        setFetchState ([ year, fetchState ]: [ number, FetchState ]) {
            const updatedState = this[year] || { fetchState, listing: null };
            updatedState.fetchState = fetchState;
            Vue.set(this, year, updatedState);
        },

        setStatements ([ year, listing ]: [ number, AvidiaStatementsList ]) {
            Vue.set(this, year, {
                fetchState: FetchState.Loaded,
                listing
            });
        },
        load (year: number): Promise<void> {

            if (this.loading(year) || this.loaded(year)) {
                return Promise.resolve();
            }

            this.setFetchState([ year, FetchState.Loading ]);

            return BankService.getAvidiaStatements(year)
                .then(response => {
                    this.setStatements([ year, response.data ]);
                }).catch(err => {
                    return storeHelper.handleError({ error: err, rethrow: true });
                });
        }
    }
});
